module.exports = __webpack_public_path__ + "media/images/project/copy-task-76245866b276480fada27b4148034181.svg";